import { useRouter } from "vue-router";

function routers() {
  const router = useRouter();

  /**
   * @description: 路由跳转
   * @param {*} path 路径
   * @param {*} query 页面传参
   * @return {*}
   */
  function linkTo(path, query = {}) {
    router.push({
      path,
      query,
    });
  }

  /**
   * @description: 路由跳转_验证登录
   * @param {*} path 路径
   * @param {*} query 页面传参
   * @return {*}
   */
  function linkTo_lsLogin(path, query = {}) {
    query.isLogin = true;
    router.push({
      path,
      query,
    });
  }

  /**
   * @description: 外链网页跳转
   * @param {*} url 网页链接
   * @return {*}
   */
  function linkTo_H5(url) {
    location.href = url;
  }

  /**
   * @description: 返回上个页面
   * @param {*}
   * @return {*}
   */
  function goBack() {
    router.go(-1);
  }

  return {
    linkTo,
    linkTo_lsLogin,
    linkTo_H5,
    goBack,
  };
}

export default routers;
